import React from 'react';

import {
  SimpleEditor,
  type SimpleEditorValue,
} from '@/components/tiptap-templates/simple/simple-editor';

type CuriousTiptapContent = Record<string, unknown>;

type CuriousTiptapEditorProps = {
  value?: CuriousTiptapContent | null;
  onChange?: (value: CuriousTiptapContent) => void;
  readOnly?: boolean;
  className?: string;
  /** Document artifact id so image uploads go to media/user/<artifactId>/images (same as OCR). */
  imageUploadDocStem?: string;
  /** Called when character/word count changes (e.g. for footer display). */
  onCharacterCountChange?: (counts: { characters: number; words: number }) => void;
};

export const CuriousTiptapEditor: React.FC<CuriousTiptapEditorProps> = ({
  value,
  onChange,
  readOnly = false,
  className = '',
  imageUploadDocStem,
  onCharacterCountChange,
}) => {
  const handleChange = (next: SimpleEditorValue) => {
    if (!onChange) return;
    onChange(next as CuriousTiptapContent);
  };

  return (
    <div className={className}>
      <SimpleEditor
        value={(value as SimpleEditorValue | null | undefined) ?? null}
        onChange={handleChange}
        readOnly={readOnly}
        imageUploadDocStem={imageUploadDocStem}
        onCharacterCountChange={onCharacterCountChange}
      />
    </div>
  );
};

export default CuriousTiptapEditor;
